import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-financeiro-modal-orcamento',
  templateUrl: './financeiro-modal-orcamento.component.html',
  styleUrls: ['./financeiro-modal-orcamento.component.css'],
  standalone: false
})
export class FinanceiroModalOrcamentoComponent implements OnChanges {
  @Input() orcamento: any;
  @Input() meses: string[] = [];
  @Input() tipos: string[] = [];
  @Input() titulo: string = 'Novo Orçamento';
  @Input() labelTipo: string = 'Tipo';
  @Input() modoEdicao: boolean = false;

  semanas = [
    { id: 1, descricao: '1ª Semana' },
    { id: 2, descricao: '2ª Semana' },
    { id: 3, descricao: '3ª Semana' },
    { id: 4, descricao: '4ª Semana' },
    { id: 5, descricao: '5ª Semana' }
  ];

  listaMeses: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['meses'] && this.meses) {
      this.listaMeses = this.meses.map((mes, index) => ({
        id: index + 1,
        descricao: mes
      }));
    }
  }

  @Output() fechar = new EventEmitter<void>();
  @Output() salvar = new EventEmitter<void>();
  @Output() deletar = new EventEmitter<number>();

  errors: any = {};

  fecharModal() {
    this.errors = {};
    this.fechar.emit();
  }

  salvarOrcamento() {
    if (this.validar()) {
      this.salvar.emit();
    }
  }

  validar(): boolean {
    this.errors = {};
    if (!this.orcamento.mes) this.errors.mes = true;
    if (!this.orcamento.semana) this.errors.semana = true;
    if (this.orcamento.tipoConta === undefined && this.orcamento.tipoReceita === undefined) {
      // Pelo menos um tipo deve estar presente
    } else {
      if (this.orcamento.tipoConta !== undefined && !this.orcamento.tipoConta) this.errors.tipo = true;
      if (this.orcamento.tipoReceita !== undefined && !this.orcamento.tipoReceita) this.errors.tipo = true;
    }
    if (!this.orcamento.valor) this.errors.valor = true;

    return Object.keys(this.errors).length === 0;
  }

  excluirOrcamento() {
    if (this.orcamento && this.orcamento.id) {
      this.deletar.emit(this.orcamento.id);
    }
  }
}
